import { Api } from '@Services/api'
import { DBUser } from '@User/Domain/Model/User'
import UsersDataSource from '../UsersDataSource'
import { CreateUserPayload } from './Entity/User'

export class UserAPI implements UsersDataSource {
    axios = new Api()

    async createUser(user: CreateUserPayload): Promise<DBUser> {
        const { data } = await this.axios.post('/user', user)
        return data
    }

    async getUserById(id: string): Promise<DBUser> {
        const { data } = await this.axios.get(`/user/${id}`)
        return data
    }

    async getUsers(): Promise<DBUser[]> {
        const { data } = await this.axios.get('/user')
        // if (import.meta.env.DEV) {
        //     return data
        // }
        const tenants = import.meta.env.VITE_AUTH_DOMAIN_TENANT.split(',')
        return data.filter(({ mail }: DBUser) =>
            tenants.some(tenant => mail?.includes(tenant))
        )
    }

    async updateUser(user: DBUser): Promise<DBUser> {
        const { data } = await this.axios.put(`/user/${user.uid}`, user)
        return data
    }

    async disableUser(id: string): Promise<void> {
        await this.axios.delete(`/user/${id}`)
    }

    async enableUser(id: string): Promise<void> {
        await this.axios.put(`/user/${id}/enable`)
    }

    getSource(): string {
        return this.axios.getSource()
    }
}
